(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polyflor-matching-strips"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPolyStrips(root) {
      if (!root || root.dataset.polyInit === '1') return;
      root.dataset.polyInit = '1';

      var viewport = root.querySelector('[data-poly-viewport]');
      var track = root.querySelector('[data-poly-track]');
      var prevBtn = root.querySelector('[data-poly-prev]');
      var nextBtn = root.querySelector('[data-poly-next]');
      if (!viewport || !track || !prevBtn || !nextBtn) return;

      var currentOffset = 0;

      function getScrollStep() {
        var item = track.querySelector('.poly-strips__item');
        if (!item) return viewport.clientWidth;
        var itemWidth = item.getBoundingClientRect().width + 10; // 10 = gap
        var visibleItems = Math.max(1, Math.floor(viewport.clientWidth / itemWidth));
        return itemWidth * Math.max(1, visibleItems - 1);
      }

      function maxOffset() {
        return Math.max(0, track.scrollWidth - viewport.clientWidth);
      }

      function applyOffset() {
        var max = maxOffset();
        if (currentOffset < 0) currentOffset = 0;
        if (currentOffset > max) currentOffset = max;
        track.style.transform = 'translateX(-' + currentOffset + 'px)';
        prevBtn.disabled = currentOffset <= 0;
        nextBtn.disabled = currentOffset >= max;
      }

      prevBtn.addEventListener('click', function () {
        currentOffset -= getScrollStep();
        applyOffset();
      });
      nextBtn.addEventListener('click', function () {
        currentOffset += getScrollStep();
        applyOffset();
      });

      var touchStartX = 0;
      var touchDeltaX = 0;
      viewport.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchDeltaX = 0;
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        touchDeltaX = e.touches[0].clientX - touchStartX;
      }, { passive: true });
      viewport.addEventListener('touchend', function () {
        if (Math.abs(touchDeltaX) > 40) {
          currentOffset += touchDeltaX > 0 ? -getScrollStep() : getScrollStep();
          applyOffset();
        }
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(applyOffset, 120);
      });

      applyOffset();
    }

    document.querySelectorAll('[data-poly-strips]').forEach(initPolyStrips);

    document.addEventListener('shopify:section:load', function (e) {
      var sectionEl = e.target.querySelector('[data-poly-strips]');
      if (sectionEl) initPolyStrips(sectionEl);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
